<div class="main-wrapper">
  <div class="main-content">
    <header>

      <div class="head-line">
        <span (click)="navigateBack()">
                 <i class="fa-solid fa-circle-arrow-left" style="cursor:pointer;font-size: 15px;" title="back"></i>
                </span>

        <p>Template Mapping</p>
      </div>
      <div class="user-wrapper">
        <!-- <p>{{storedData.agencyRefId.agencyName}}</p> -->

        <div>
          <!-- <img class="log1" [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/images/user1.jpeg'"> -->
        </div>
      </div>
    </header>
    <main class="main-2">
      <form [formGroup]="reportForm">
        <div class="container">
          <div class="projects">


            <div class="two-screen">
              <!---sec sidebar-->

              <div class="second-side">

                <div class="form-group">
                  <label for="templateType">Template Name</label>
                 
                  <input type="text" formControlName="templateName" class="form-control">
                </div>

                <div class="form-group">
                  <label for="templateType">Subject</label>
                 
                  <textarea formControlName="subject" class="form-control"></textarea>
                </div>


                <div class="form-group">
                  <label for="pdfFormat">Body Template</label>
                  <!-- <editor apiKey="vx5x1wqpur75bbzgks6x3vj45qbcshx17aajrh8yfgwo7zqs" formControlName="pdfFormat"
                    [init]="editorConfig" (onInit)="onEditorInit($event)"></editor> -->

              <editor formControlName="pdfFormat" id="pdfFormat"  apiKey="vx5x1wqpur75bbzgks6x3vj45qbcshx17aajrh8yfgwo7zqs"
              [init]="editorConfig" (onInit)="onEditorInit($event)"></editor>

                </div>

                <div class="form-group mt-3">
                  <label>Upload Files</label>

                  <div formArrayName="uploads">
                    <div *ngFor="let upload of uploads.controls; let i = index" [formGroupName]="i"
                      class="d-flex align-items-center gap-2 mb-2">

                      <!-- File name -->
                      <input type="text" class="form-control" formControlName="filename" placeholder="File Name"
                        style="max-width: 200px;" readonly/>

                      <!-- File upload -->
                      <input type="file" class="form-control" (change)="onFileSelected($event, i)"
                        style="max-width: 220px;" />

                      <!-- Uploaded S3 URL -->
                      <input type="text" class="form-control" formControlName="s3url" placeholder="S3 URL" readonly
                        style="flex:1;" />

                      <!-- Remove button -->
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeUpload(i)">
                        ✕
                      </button>
                    </div>
                  </div>

                  <button type="button" class="btn btn-success mt-2" (click)="addUpload()">+ Add File</button>
                </div>


                <div class="form-group mt-3">
                  <button type="submit" class="btn btn-primary" (click)="onSubmit()">
                    Save Report
                  </button>
                </div>


              </div>
            </div>
          </div>
        </div>
      </form>
    </main>
  </div>
</div>